export default "__VITE_ASSET__a6947262__"